import React from 'react';

import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Chef.css';

const Chef = () => (
  <div className="app__bg app__wrapper section__padding">
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src={images.chef} alt="chef_image" />
    </div>
    <div className="app__wrapper_info">
      <SubHeading title="The Regal Guarantee" />
      <h1 className="headtext__cormorant">Excellence is non-negotiable</h1>

      <div className="app__chef-content">
        <div className="app__chef-content_quote">
          <img src={images.quote} alt="quote_image" />
          <p className="p__opensans">Our clientele consists of the most demanding people in the world.</p>
        </div>
        <p className="p__opensans"> It is for this reason that we expect excellence from every employee, whether they be head chef or a dishwasher. At Regal we can comfortably guarantee an elite experience. Anything else is embarassing.</p>
      </div>

      <div className="app__chef-sign">
        <p>Max Regal</p>
        <p className="p__opensans">Head Chef</p>
       </div>
    </div>
  </div>
);

export default Chef;